import { Component, Input } from '@angular/core';
import { BonusShopEnum, BonusShopPage, BonusShopType, GoodsItem } from '../bonus-shop.types';
import { UserService } from '../../../core/services/user/user.service';
import { UserCompPointsService } from '../../../core/services/user/user-comp-points.service';
import { TranslatePipe } from '../../../core/shared/translation/translate.pipe';
import { RouterLink } from '@angular/router';
import { SafePipe } from 'ngx-unificator/pipes';
import { DecimalPipe, NgClass } from '@angular/common';
import { ModalService } from '../../../core/modal/modal.service';
import { TermsComponent } from '../../../core/shared/components/terms/terms.component';
import { BoxComponent } from '../../../core/shared/components/box/box.component';
import { BtnComponent } from '../../../core/shared/components/btn/btn.component';

@Component({
  selector: 'app-bonus-shop-tab',
  templateUrl: './bonus-shop-tab.component.html',
  styleUrls: ['./bonus-shop-tab.component.scss'],
  imports: [TranslatePipe, RouterLink, SafePipe, DecimalPipe, NgClass, TermsComponent, BoxComponent, BtnComponent],
})
export class BonusShopTabComponent {
  @Input() bonusStorePage: BonusShopPage;
  @Input() bonusShopType: BonusShopType;

  constructor(
    public user: UserService,
    public compPoints: UserCompPointsService,
    private _modal: ModalService,
  ) {}

  public async showBonusStoreModal(bonus: GoodsItem, boxImage: string, allbonuses: GoodsItem[], bonusShopType: BonusShopType) {
    const allLootboxIds = allbonuses.map(e => e.LootboxId);
    const component = await import('../../../core/modal/components/lazy/bonus-store-modal/bonus-store-modal.component');
    await this._modal.openLazy(component?.BonusStoreModalComponent, {
      template: 'CLEAR',
      data: {
        ...bonus,
        bonusShopType,
        allLootboxIds,
        boxImage,
      },
    });
  }

  protected readonly BONUS_SHOP_TYPE = BonusShopEnum;
}
